import { useQuery } from "@tanstack/react-query";

import { getHumidityLevelsOptions } from "../../generated/client/octalog-service/@tanstack/react-query.gen";

export function useGetHumidityLevels() {
  return useQuery({
    ...getHumidityLevelsOptions(),
  });
}
